import React, { lazy, useContext } from "react";
import { createBrowserRouter, Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { SPECIALIST_CABINET_PREVIEW } from "../service/specialistService";
const Layout = lazy(() => import("../layouts/index"));
const Home = lazy(() => import("../pages/home"));
const Mission = lazy(() => import("../pages/mission/mission"));
const Objectives = lazy(() => import("../pages/objectives/objectives"));
const Values = lazy(() => import("../pages/values/values"));
const Portfolio = lazy(() => import("../pages/portfolio/portfolio"));
const Gallery = lazy(() => import("../pages/gallery/Gallery"));
const Founders = lazy(() => import("../pages/founders/founder"));
const Contact = lazy(() => import("../pages/contact/contact"));
const OnlineChat = lazy(() => import("../pages/onlinechat/online"));
const Roomrental = lazy(() => import("../pages/roomrental/index"));
const PaymentModal = lazy(() =>
  import("../pages/roomrental/PaymentModal/payment")
);
const ChatDetail = lazy(() =>
  import("../pages/onlinechat/chatdetail/chatdetail")
);
const Services = lazy(() => import("../pages/services/services"));
const ServicesDetail = lazy(() =>
  import("../pages/services/servicesdetail")
);
const Team = lazy(() => import("../pages/team/team"));
const NotFound = lazy(() => import("../pages/404"));
const Psychologist = lazy(() =>
  import("../pages/team/psychologist/psychologist")
);
const Login = lazy(() => import("../pages/registration/login"));
const Register = lazy(() => import("../pages/registration/register"));
const Profile = lazy(() => import("../pages/profile/profile"));
const SpecialistCabinet = lazy(() => import("../pages/specialist/cabinet"));
const SupportVideos = lazy(() =>
  import("../pages/profile/profile_content/supportvideo")
);
const Trainings = lazy(() =>
  import("../pages/trainings")
);
const Favorites = lazy(() =>
  import("../pages/profile/profile_content/favorites")
);
const Reports = lazy(() =>
  import("../pages/profile/profile_content/reports")
);
const Materials = lazy(() =>
  import("../pages/profile/profile_content/materials")
);
const Seminar = lazy(() =>
  import("../pages/profile/profile_content/onlineseminar")
);
const CommunicationPage = lazy(() =>
  import("../pages/profile/profile_content/seminardetails")
);
const Video = lazy(() => import("../pages/profile/profile_content/video"));
const FooterPrivacy = lazy(() =>
  import("../layouts/footer/footerPrivacy/footer_privacy")
);
const Blog = lazy(() => import("../pages/blog/index"));
const BlogDetail = lazy(() => import("../pages/blog/detail"));
const FaqPage = lazy(() => import("../pages/faq"));
const TermsAndConditionsPage = lazy(() => import("../pages/terms"));
const Diagnostics = lazy(() => import("../pages/diagnostics"));
const TestsPage = lazy(() => import("../pages/tests"));
const PastTestsPage = lazy(() => import("../pages/tests/past-tests"));
const TestDetailPage = lazy(() => import("../pages/tests/detail"));
const TestResultPage = lazy(() => import("../pages/tests/result"));
const PartnerLanding = lazy(() => import("../pages/partner"));
const PartnerApplyPage = lazy(() => import("../pages/partner/apply"));
const CustomerPartnerPage = lazy(() => import("../pages/partner/customer"));
const CompanyPartnerPage = lazy(() => import("../pages/partner/company"));
const PaymentResult = lazy(() =>
  import("../pages/payment-result/PaymentResult")
);

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/onlinechat",
        element: <OnlineChat />,
      },
      {
        path: "/chatdetail",
        element: <ChatDetail />,
      },
      {
        path: "/xidmətlərimiz",
        element: <Services />,
      },
      {
        path: "/servicesdetail/:slug",
        element: <ServicesDetail />,
      },
      {
        path: "/roomrental",
        element: <Roomrental />,
      },
      {
        path: "/payment",
        element: <PaymentModal />,
      },
      {
        path: "/success-payment",
        element: <PaymentResult />,
      },
      {
        path: "/error-payment",
        element: <PaymentResult />,
      },
      {
        path: "/mütəxəssislər",
        element: (
          <ProtectedRoute>
            <Team />
          </ProtectedRoute>
        ),
      },
      {
        path: "/komandamız",
        element: <Navigate to="/mütəxəssislər" replace />,
      },
      {
        path: "/not-found",
        element: <NotFound />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
      {
        path: "/privacy-policy",
        element: <FooterPrivacy />,
      },
      {
        path: "/missiyamız",
        element: <Mission />,
      },
      {
        path: "/founders",
        element: <Founders />,
      },
      {
        path: "/objectives",
        element: <Objectives />,
      },
      {
        path: "/values",
        element: <Values />,
      },
      {
        path: "/portfolio",
        element: <Portfolio />,
      },
      {
        path: "/galeriya",
        element: <Gallery />,
      },
      {
        path: "/psychologist/:id",
        element: <Psychologist />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/registration",
        element: <Navigate to="/qeydiyyat" replace />,
      },
      {
        path: "/qeydiyyat",
        element: <Register />,
      },
      {
        path: "/profile",
        element: (
          // <ProtectedRoute>
          <Profile />
          // </ProtectedRoute>
        ),
      },
      {
        path: "/mutaxassis",
        element: SPECIALIST_CABINET_PREVIEW ? (
          <SpecialistCabinet />
        ) : (
          <ProtectedRoute>
            <SpecialistCabinet />
          </ProtectedRoute>
        ),
      },
      {
        path: "/profile/supportvideos",
        element: (
          // <ProtectedRoute>
            <SupportVideos />
          // </ProtectedRoute>
        ),
      },
      {
        path: "/profile/supportvideos/:id",
        element: (
          // <ProtectedRoute>
            <Video />
          // </ProtectedRoute>
        ),
      },
      {
        path: "/profile/trainings",
        element: (
            <Trainings />
        ),
      },
      {
        path: "/profile/favorites",
        element: (
            <Favorites />
        ),
      },
      {
        path: "/profile/reports",
        element: <Reports />,
      },
      {
        path: "/profile/materials/:slug",
        element: <Materials />,
      },
      {
        path: "/profile/materials",
        element: <Materials />,
      },
      {
        path: "/onlineseminar",
        element: (
            <Seminar />
        ),
      },
      {
        path: "/profile/communication/:id",
        element: (
            <CommunicationPage />
        ),
      },
      {
        path: "/profile/video",
        element: (
          // <ProtectedRoute>
            <Video />
          // </ProtectedRoute>
        ),
      },
      {
        path: "/blog",
        element: <Blog />,
      },
      {
        path: "/blog/:slug",
        element: <BlogDetail />,
      },
      {
        path: "/faq",
        element: <FaqPage />,
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditionsPage />,
      },
      {
        path: "/diagnostics",
        element: <Diagnostics />,
      },
      {
        path: "/testler",
        element: <TestsPage />,
      },
      {
        path: "/kecmis-testler",
        element: <PastTestsPage />,
      },
      {
        path: "/testler/:testId",
        element: <TestDetailPage />,
      },
      {
        path: "/testler/netice/:testId",
        element: <TestResultPage />,
      },
      {
        path: "/partnyor-ol",
        element: <PartnerLanding />,
      },
      {
        path: "/partner-network",
        element: <PartnerLanding />,
      },
      {
        path: "/partnyor-sebekesi",
        element: <PartnerLanding />,
      },
      {
        path: "/partner-network/muraciet",
        element: <PartnerApplyPage />,
      },
      {
        path: "/partnyor-ol/musteri",
        element: <CustomerPartnerPage />,
      },
      {
        path: "/partnyor-ol/sirket",
        element: <CompanyPartnerPage />,
      },
      {
        path: "/sirket-muracieti",
        element: <CompanyPartnerPage />,
      },
      {
        path: "/korporativ-muraciet",
        element: <CompanyPartnerPage />,
      },
    ],
  },
]);
